if (!customElements.get('panzoom-element')) {
  class PanzoomElement extends HTMLElement {
    constructor() {
      super();
      this.panzoom = null;
    }
    
    connectedCallback() {      
      this.addEventListener('click', e => {  
        if (this.panzoom) {
          this.panzoom.zoom(1);
          this.panzoom = null;
          this.classList.remove('zoomed');
          setTimeout(() => {
            this.querySelector('[data-panzoom]').removeAttribute('style');
            this.removeAttribute('style');
          }, 10);
          return;
        }
           
        const clickedElement = e.target.closest('[data-panzoom]');
        if (!clickedElement || !Panzoom) return;
        
        this.classList.add('zoomed');
        
        this.panzoom = Panzoom(clickedElement, {
          contain: "outside",
          canvas: true
        });
                
        clickedElement.parentElement.addEventListener('pointermove', (event) => {
          this.panzoom.pan((event.movementX * -2), (event.movementY * -2), { relative: true });
        })
        
        this.panzoom.zoom(2, { animate: true });
      });
    }
  }
  
  customElements.define('panzoom-element', PanzoomElement);
}
